import Feature from 'Services/Feature';

window.MySupport = {
    getForm: function () {
        if (Feature.isEnabled('intercom')) {
            window.Intercom('show');
        } else if (Feature.isEnabled('xeno') && typeof _xeno != "undefined") {
            _xeno.show();
        } else {
            console.log('Xeno or Intercom not available');
        }
    }
};

window.MyFacture = {

	ajaxQueue: [],

	overviewNav : _.throttle(function(type, id, filter, way){

		MyFacture.startWait();

		var url = '';
		switch(type){
			case 'ticket':
				url = 'support_tickets';
				break;
			case 'opportunity':
				url = 'prospection_opportunity';
				break;
			case 'item':
			case 'service':
				url = 'catalogueitem';
				break;
			case 'client':
			case 'supplier':
			case 'prospect':
				url = 'thirds';
				break;
			case 'people':
				url = 'people';
				break;
			case 'massmailing':
				url = 'massmailing_campaign';
				break;
			case 'estimate':
			case 'invoice':
			case 'creditnote':
			case 'order':
			case 'delivery':
			case 'proforma':
			case 'model':
				url = 'doc';
				break;
			case 'purOrder':
			case 'purDelivery':
			case 'purInvoice':
			case 'purCreditNote':
				url = 'purchases_purchases';
				break;
			case 'transactions':
				url = 'bankreconciliation_transaction';
				break;
		}

		MyFacture.post(url+"&action=nav", {type:type, id:id, filter:filter, way:way}, function(data){
			if (data.error === "Y")
				MyWindow.alert(Loc.g("Une erreur est survenue"), {type:"error"});
			else {
				if (data.success === "Y" && data.redirect !== undefined)
					Utils.relocate(data.redirect);
				else {
					var options = {type:"warning"};
					if (data.urlListing !== undefined){
						var buttons	= { buttons : [
                            {text : Loc.g("Fermer"), click : function(){
                                $(this).dialog("close");
                            }},
                            {text : Loc.g("Retourner au listing"), click : function(){
								Utils.relocate(data.urlListing);
							}}
						]};
						options = $.extend(true, options, buttons);
					}
					MyWindow.alert(Loc.g("Il n'y a plus d'élement à charger. <br /><br /> Retourner à la liste pour affiner votre recherche."), options);
				}
				MyFacture.stopWait();
			}
		}, "json");

	},1024),

	removeLoaderDash: function(){
		$('#loaderdash').fadeOut('slow', function(){$('#loaderdash').remove();});
	},

	beLoading: function(me){

		var oldColor;
		var oldText;

		if (me.hasClass('loading')){
			oldColor = me.attr('oldColor');
			oldText = me.attr('oldText');
			me.removeAttr('oldColor');
			me.removeAttr('oldText');
			me.css({'background-color' : oldColor});
			me.html(oldText);
			me.removeClass('loading');
		} else {
			oldText = me.html();
			me.html('<i class="fa fa-spinner fa-spin"></i> '+Loc.g('Chargement')+"...");
			me.attr('oldText' , oldText);
			me.addClass('loading');

		}
	},


	init: function(){

		this.initCsrfToken();
		MyFacture.singleCustomForm();
		MyFacture.customForm();

		MyFacture.initFastSearch();

        $("#menu .contentMenu .tabsMenu .tabSubmenu").mouseover(function() {
            $(this).parent().children('a').css('color','white');
		}).mouseout(function () {
			$(this).parent().children('a').css('color', 'rgba(255,255,255,0.7)');
		});

	},

	initCsrfToken: function(){
		// CRSF setup
		$(document).bind("ajaxSend", function( event, jqXhr, settings ) {
			MyFacture.setupCsrfToken(jqXhr);
		});

		$(document).trigger('MyFacture.afterInit');
	},

	setupCsrfToken: function(xhr) {
        var csrf_token = $('meta[name="saas-csrf-token"]').attr('content');

		xhr.setRequestHeader("X-CSRF-TOKEN", csrf_token);
		xhr.done(function( data, textStatus, jqXHR ) {
			MyFacture.refreshCsrfToken(jqXHR);
		})
		.fail(function( jqXHR, textStatus, errorThrown ) {
			MyFacture.refreshCsrfToken(jqXHR);
		});
	},

	refreshCsrfToken: function(jqXhr) {
        // Refresh Csrf token in DOM if provided in response
        try {
            var token = jqXhr.getResponseHeader('X-CSRF-TOKEN');
            if (token) {
                $('meta[name="saas-csrf-token"]').attr('content', token);
            }
        } catch (e) {
            // no csrf token header
        }
    },

	initFastSearch: function(){

		var $fastSearchCategory = $('#fast-search-cat');
		var $fastSearchInput	= $('#fast-search-input');

		$fastSearchCategory.unbind('change');
		$fastSearchCategory.change(function(){

			var valUpdate = $fastSearchCategory.val();
			MyFacture.post('staff', {fastsearchopen:valUpdate, action:'updateFastSearch'});
			MyFacture.initFastSearch();

		});

		var fsType = $fastSearchCategory.val();
		$('#fast-search .token-input-list').remove();
		$fastSearchCategory.attr('class', 'no-customform fast-select select' + fsType);

		switch(fsType){
			case "people":
				TokenInput.autoPeople("#fast-search-input", 1, 'true', '',
					function(item){ // ADD
						var itemId = item.id;
						MyFacture.startWait();
						window.location = "/?_f=people&id="+itemId;
					}, undefined, undefined, 'main_search'
				);
				break;
			case "contact":

				var options = {
					onAdd  : function(item){ // ADD
                        MyFacture.startWait();
                        if (item && item.url){
                            window.location = item.url;
                        } else{
                            Push.error(Loc.g("Une erreur est survenue, veuillez ré-essayer ultérieurement."), false)
                            MyFacture.stopWait();
                        }
					},
					url: '&search_type=main_search'
				};

				$fastSearchInput.attr('placeholder', Loc.g('Rechercher un client, prospect ou fournisseur'));
				Autocomplete.third($fastSearchInput, options);

				break;
			case "item":
				TokenInput.autoItem("#fast-search-input", 'item|service', {}, 1,
					function(item){
						var itemId = item.id.split('_');
						var declidId = 0;
						if (item.declid !== undefined){
							declidId = item.declid.split('_');
						}
						MyFacture.startWait();
						window.location = "/?_f=catalogueitem&id="+itemId[1]+"&type="+item.type+"&declid="+declidId[1];
					}, undefined, 'main_search'
				);
				break;
			case "document":

				var options = {
					onAdd  : function(item){ // ADD
						MyFacture.startWait();
                        if (item && item.url) {
                            window.location = item.url;
                        } else {
                            Push.error(Loc.g("Une erreur est survenue, veuillez ré-essayer ultérieurement."), false)
                            MyFacture.stopWait();
                        }
					},
					url: '&search_type=main_search'
				};

				$fastSearchInput.attr('placeholder', Loc.g('Rechercher un document de vente'));
				Autocomplete.doc($fastSearchInput, options);

				break;
			case "purchases":
				TokenInput.autoPurchasesListing("#fast-search-input", "purOrder|purDelivery|purInvoice|purCreditNote", 1, false, 'withdeposit',
					function(item){
						MyFacture.startWait();
						window.location = item.docurl;
					}, undefined, undefined, 'main_search'
				);
				break;
			case "opportunity":
				TokenInput.autoOpportunity("#fast-search-input", function(item){
					var itemId = item.id.split('_');
					MyFacture.startWait();
					window.location = "/?_f=prospection_opportunity&action=overview&oid="+itemId[1];
				}, undefined, undefined, undefined, 'main_search');
				break;
			case "support":
				TokenInput.autoSupport('#fast-search-input', function(item){
					var itemId = item.id.split('_');
					MyFacture.startWait();
					window.location = "/?_f=support_ticket&tid="+itemId[1];
				}, undefined, undefined, 'main_search');
				break;
			case "project":
				TokenInput.autoProject('#fast-search-input', function(item){
					var itemId = item.id.split('_');
					MyFacture.startWait();
					window.location = "/?_f=project_project&action=overview&pid="+itemId[1];
				}, undefined, undefined, undefined, 'main_search');
				break;
			case "proposal":
				TokenInput.autoProposal('#fast-search-input', 'proptemplate|propdocument', 1, null,
					function(item){
						MyFacture.startWait();
						window.location = item.propurl;
					}, undefined, undefined, 'main_search'
				);
				break;
			case "sellsyadmin":
				Corporation.autoCorporation('#fast-search-input', 1, '',
					function(item){
						if(item.thirdurl == 'connection_error'){

							MyWindow.alert(Loc.g('Impossible de vous connecter pour atteindre la fiche client'), {type : 'error'});

						} else if(item.thirdurl != ''){

							if(item.newwindow == 'N'){
								MyFacture.startWait();
								window.location = item.thirdurl;
							} else {
								$('#fast-search-input').tokenInput('clear');
								window.open(item.thirdurl, '_blank');
							}

						} else if(item.status == 'deleted') {

							var msg = Loc.g('Ce compte Sellsy est supprimé et ne peut être lié à un nouveau client');
							msg += "<br/><br/>";
							msg += Loc.g('Il peut néanmoins être lié depuis la fiche d\'un client existant, par le biais de l\'action "Lier un compte"');

							MyWindow.alert(msg, {type : 'error'});
							$('#fast-search-input').tokenInput('clear');

						} else {

							var opts = {
								width	: 400,
								type	: 'warning',
								buttons : [
									{
										html: Loc.g('Annuler'),
										click: function () {
											$(this).dialog('close');
											$('#fast-search-input').tokenInput('clear')
										}
									},
									{
										html : Loc.g('Créer un prospect'),
										click : function(){
											SellsyAdmin.createThird(item.id, 'prospect');
										}
									},
									{
										html : Loc.g('Créer un client '),
										click : function(){
											SellsyAdmin.createThird(item.id, 'client');
										}
									}
								]
							}

							MyWindow.alert(Loc.g('Ce compte Sellsy n‘est synchronisé à aucun client Easybill'), opts);

						}
					}, undefined, 'main_search'
				);
				break;
		}

	},

	buildUrl: function(url){
		return "/?_f="+url;
	},

	relocate: function(action, newTarget){
		Utils.relocate(MyFacture.buildUrl(action), newTarget);
	},

	send: function(action, data, callback, dataType, queue){
		var query = $.get(MyFacture.buildUrl(action), data, callback, dataType);
		queue =  (queue === undefined) ? false : queue;

		if(queue) {
			MyFacture.ajaxQueue.push(query);
		}
	},

	post: function(action, data, callback, dataType, queue, buildFileUrl) {

		queue = (queue === undefined) ? false : queue;

		buildFileUrl = buildFileUrl === undefined ? true : buildFileUrl;
		var url = buildFileUrl ? MyFacture.buildUrl(action) : action;

		var query = $.ajax({
			type: "POST",
			url: url,
			data: data,
			success: callback,
			error: function(error){
				MyWindow.awake();
			},
			dataType: dataType
		});

		if(queue) {
			MyFacture.ajaxQueue.push(query);
		}

		return query;
	},

	cleanQueue: function() {
		if(MyFacture.ajaxQueue.length > 0) {
			for(var i in MyFacture.ajaxQueue) {
				MyFacture.ajaxQueue[i].abort();
			}
			MyFacture.ajaxQueue = [];
		}
	},

	submit: function(action, formId, callback, dataType){
		$.post(MyFacture.buildUrl(action), $("#"+formId).serialize(), callback, dataType);
	},

	ajax: function(url, data, success, dataType, type){
		type = undefined==type ? "POST" : type;
		$.ajax({url: MyFacture.buildUrl(url), data: data, success: success,dataType: dataType, type: type});
	},

	singleCustomForm: function(target){

		target =  target==undefined ? 'body' : target;
		$(target).find("*[toggle]").mouseup(function(){Utils.toogle(this);});

        $(window).scroll(function() {
            $('#loadingMask').css({'top':$(window).scrollTop()});
            $('#loadingMaskContent').css({'top':$(window).scrollTop()+300});
        });
	},

	customForm: function(target, withEvent){
		withEvent	= withEvent == undefined ? true : withEvent;
		target		= target == undefined ? 'body' : target;

		var $target = typeof target == 'object' ? target : $(target);

		$('.input-addon-autofocus', $target).click(function(){
			$(this).prev().focus();
		});

        $("select[multiple]", $target).not('.no-customform').each(function () {
            var $this = $(this);

			if((typeof ($this.data("multipleSelect")) != "object")) {

				var opts = {
					selectAllText : Loc.g('Tout Sélectionner'),
					allSelected   :	Loc.g('Tous sélectionnés'),
					countSelected : false,
					onOpen		  : function(){
						// On open, update optgroup selected attr if all options inside are selected
						$this.data('multipleSelect').updateOptGroupSelect();
					}
				};

				// CUSTOMISABLE OPTIONS
				// -- OnChange
				var change = $this.attr('onchange');
				if (change != '') {
					opts.onClick = function (view) {
						eval(change);
					};
				}
				$this.attr('onchange', "");

				// -- On blur
				var blur = $this.attr('onblur');
				if (blur != '') {
					opts.onClose = function (view) {
						eval(blur);
					};
				}
				$this.attr('onblur', "");

				// -- Add Select All option
				if ($this.attr('selectall') !== undefined) {
					opts.selectAll = $this.attr('selectall') == 'false' ? false : true;
				}

				// -- Add custom Placeholder
				if ($this.attr('placeholder') !== undefined) {
					opts.placeholder = $this.attr('placeholder');
				}

				// -- Special comportment for PrevSalesReport
                if($this.attr('multipleselecttype') === 'staffgroup'){
                    opts.onOptgroupClick = function(){
                        $('#prevSalesForm').submit();
                        MyFacture.startWait();
                    };
                    opts.onClick = function() {
                        $('#prevSalesForm').submit();
                        MyFacture.startWait();
                    };
                }

				// -- select with searchbar
                if($this.attr('withsearch')){
                    opts.filter = true;
                }

                if(!$this.attr('ignoreInitMyFacture')){
                    $this.multipleSelect(opts);
                }

				// Init multipleSelect with options

                // To add placeholder to search field
				$this.parent().find('.ms-parent .ms-drop .ms-search').prepend('<div class="input-addon prepend bl-1"><i class="fa fa-search"><xsl:comment/></i></div>');
                $this.parent().find('.ms-parent .ms-drop .ms-search input').attr('placeholder', 'Rechercher');
			}
		});

		$('[timepicker]:visible', $target).each(function(){

			var $this = $(this);

			if((typeof ($this.data("timepickerSettings")) != "object")){

				var isAgenda        = $this.attr('data-isagenda') != undefined && $this.attr('data-isagenda') == 'Y' ? 'Y' : 'N';
				var hourformat      = $this.attr('timepickerformat');
				var startTimeAgenda = $this.attr('data-agendaStartTime');
				var endTimeAgenda   = $this.attr('data-agendaEndTime');
				var startempty      = $this.attr('timeempty');
				var timestep        = $this.attr('timestep') != undefined ? parseInt($this.attr('timestep'),10) : 5;
				var forceRoundTime  = $this.attr('forceRoundTime') != undefined && $this.attr('forceRoundTime') == 'false' ? false : true;
				var timeformat = "g:i a";
				if (hourformat == '24'){
					timeformat ='H:i' ;
				}

				var options = {
					step: timestep,
					forceRoundTime: forceRoundTime,
					timeFormat: timeformat
				};

				if(isAgenda == 'Y' && endTimeAgenda !== '00:00'){
					options.minTime = startTimeAgenda;
					options.maxTime = endTimeAgenda;
				}

				$this.timepicker(options);
				if ($this.val() == "" && !startempty){
					$this.timepicker('setTime', new Date());
				}

			}

		});

		$('[datepicker]', $target).each(function(){

			var $this = $(this);

			if((typeof ($this.data("datepicker")) != "object")){

				var lang		= window.App.lang;
				var format		= $this.attr('format');
				var dateFormat	= "dd/mm/yy";

				switch (format) {
					case 'mdy':
						dateFormat = "mm/dd/yy";
						break;
				}

				$.datepicker.setDefaults($.datepicker.regional[lang]);
				var datePickerOption = {
					dateFormat			: dateFormat,
					showOtherMonths		: true,
					selectOtherMonths	: true,
                    changeMonth			: true,
                    changeYear			: $this.attr('changeYear') != 'false'
				};

				// If year update is not allowed, we don't want to display it
				if(!datePickerOption.changeYear){

					datePickerOption.dateFormat = datePickerOption.dateFormat.replace('/yy', '');
					datePickerOption.beforeShow = function(input, date_picker){
						date_picker.dpDiv.addClass('recurrent-datepicker');
					};
				}

				if(!_.isUndefined($this.attr('minDate'))){

					var minDate = $this.attr('minDate').split('-');
					// Real month = (month - 1), https://www.w3schools.com/jsref/jsref_obj_date.asp
					datePickerOption.minDate = new Date(minDate[0], (minDate[1] - 1), minDate[2]);
				}

				if(!_.isUndefined($this.attr('maxDate'))){

					var maxDate = $this.attr('maxDate').split('-');
					// Real month = (month - 1), https://www.w3schools.com/jsref/jsref_obj_date.asp
					datePickerOption.maxDate = new Date(maxDate[0], (maxDate[1] - 1), maxDate[2]);
				}

				var connectedTo = $this.attr('connectedto');
				if (connectedTo !== undefined){

					datePickerOption.onSelect = function(selectedDate){

						$this.trigger('change');
						$( "#"+connectedTo ).datepicker( "option", "minDate", selectedDate );
					};

					datePickerOption.onClose = function(){
						 $( "#"+connectedTo ).focus();
					};
				}

				$this.datepicker(datePickerOption);
			}
		});

		$('.cftoInstanceThird', $target).each(function() {
			var idToken		= $(this).attr('id');
			var arrayCfId	= idToken.split('_');
			var cfid		= arrayCfId[2];
			// on check si le tokenInput est déjà instancier
			if((typeof ($("#cf_third_"+cfid).data("tokenInputObject")) != "object")){
				TokenInput.autoContactListing($('#cf_third_'+cfid), $('#thirdType_'+cfid).val(), $('#thirdMax_'+cfid).val(), true, '');
			}
		});

		$('.cftoInstanceItem', $target).each(function() {
			var idToken = $(this).attr('id');
			var arrayCfId = idToken.split('_');
			var cfid = arrayCfId[2];
			// on check si le tokenInput est déjà instancier
			if((typeof ($("#cf_item_"+cfid).data("tokenInputObject")) != "object")){
				TokenInput.autoItem($('#cf_item_'+cfid), $('#itemType_'+cfid).val(), 'noDecli', $('#itemMax_'+cfid).val());
			}
		});

		$('.cftoInstancePeople').each(function() {
			var idToken = $(this).attr('id');
			var arrayCfId = idToken.split('_');
			var cfid = arrayCfId[2];
			// on check si le tokenInput est déjà instancier
			if((typeof ($("#cf_people_"+cfid).data("tokenInputObject")) != "object")){
				TokenInput.autoPeople($('#cf_people_'+cfid), $('#peopleMax_'+cfid).val(), true, '');
			}
		});

		$('.cftoInstanceStaff').each(function() {
			var idToken = $(this).attr('id');
			var arrayCfId = idToken.split('_');
			var cfid = arrayCfId[2];
			// on check si le tokenInput est déjà instancier
			if((typeof ($("#cf_staff_"+cfid).data("tokenInputObject")) != "object")){
				TokenInput.autoContactListing($('#cf_staff_'+cfid), 'staff', $('#staffMax_'+cfid).val(), true, '');
			}
		});


		$('[uploadfile]', $target).each(function(){

			var me = $(this);

			if(!me.hasClass('uploadfilesetup')){
				me.fineUploader({
					debug		: false,
					template	: $(this).attr('template'),
					element		: this,
					multiple	: ($(this).attr('multipleUpload') == "true") ? true : false,
					maxuploadsize: $(this).attr('maxuploadsize'),
					validation: {
						allowedExtensions: $(this).attr('alloweduploadtypes').split(','),
						sizeLimit: $(this).attr('maxuploadsize')

					},
					chunking: {
						enabled: false,
						concurrent: {enabled: false}
					},
					request: {
						endpoint: "/" + $(this).attr('action'),
						method: 'POST'
					},

					messages : {
						typeError : Loc.g('Le fichier {file} n\'a pas une extension valide. Extensions valides: {extensions}.'),
						sizeError : Loc.g('le fichier {file} est trop gros. Taille limite : {sizeLimit}.')
					}

				}).off('submit').on('submit', function (event, id, name) {

					$('#email_isUploadOkay').val('N');
				}).off('error').on('error', function (id, name, errorReason, xhrOrXdr) {
					console.log(id, name, errorReason, xhrOrXdr);
				}).off('complete').on('complete', function (event, id, name, data) {
					$('#email_isUploadOkay').val('Y');
					eval(me.attr('backjs'));
				});
			}


			me.addClass('uploadfilesetup');
		});

		$('.redactor:visible', $target).each(function(){

			var $this = $(this);

			if((typeof ($this.data("redactor")) != "object")) {

				var opts = {};
				opts.minHeight = $this.height();
				opts.shortcuts = false;
				opts.lang = window.App.lang;

				opts.tidyHtml = false;
				opts.removeEmptyTags = false;
				opts.linebreaks = true;
                opts.changeCallback = function(content) {
                    $this.attr('contentChanged', true);
                };

				if ($this.hasClass('noButtons')) {
					opts.toolbar = false;
					opts.buttons = [];
				} else if ($this.hasClass('linkButtons')) {
					opts.buttons = ['link'];
				} else if ($this.hasClass('ultraLightButtons')) {
					opts.buttons = ['bold', 'italic'];
				} else if ($this.hasClass('lightButtons')) {
					opts.buttons = ['html', 'bold', 'italic', '|', 'unorderedlist', '|', 'alignleft', 'aligncenter', 'alignright', 'justify'];
				} else if ($this.hasClass('lightButtonsWithLink')) {
					opts.buttons = ['html', 'link', 'bold', 'italic', '|', 'unorderedlist', '|', 'alignleft', 'aligncenter', 'alignright', 'justify'];
				} else if ($this.hasClass('lightButtonsWithLinkNoBlank')) {
					opts.buttons = ['html', 'link', 'bold', 'italic', '|', 'unorderedlist', '|', 'alignleft', 'aligncenter', 'alignright', 'justify'];
				} else if ($this.hasClass('lightButtonsWithoutAlignment')) {
					opts.buttons = ['html', 'bold', 'italic', '|', 'unorderedlist'];
				} else if ($this.hasClass('tillButtons')) {
					opts.buttons = ['bold', 'italic', '|', 'unorderedlist', '|', 'alignment'];
				} else if ($this.hasClass('emailButtons')) {
					opts.buttons = [
						'bold', 'italic', 'underline', 'unorderedlist', 'orderedlist', 'alignleft', 'aligncenter', 'alignright', 'image', 'link'
					];
					opts.plugins = ['fontcolor', 'fontsize'];
					opts.removeEmptyTags = true;
                } else if ($this.hasClass('agendaButtons')) {
					opts.buttons = [
						'bold', 'italic', 'underline', '|', 'unorderedlist', '|', 'alignleft', 'aligncenter', 'alignright', 'justify', '|', 'link'
					];
                } else if ($this.hasClass('emailCustomButtons')) {
                    opts.buttons = [
                        'html', '|', 'bold', 'italic', 'underline', 'unorderedlist', 'orderedlist', 'alignleft', 'aligncenter', 'alignright',
						'|', 'image', 'table', 'link',
						'|', 'alignment', 'horizontalrule'
                    ];
					opts.plugins = ['fontcolor', 'fontsize'];
					opts.removeEmptyTags = true;
				} else if ($this.hasClass('emailEngineCustomEmailTemplateButtons')) {
					opts.buttons = [
                        'bold', 'italic', 'underline', 'unorderedlist', 'orderedlist', 'alignleft', 'aligncenter', 'alignright',
						'|', 'image', 'link',
						'|', 'alignment', 'horizontalrule'
                    ];
					opts.plugins = ['fontcolor', 'fontsize'];
					opts.removeEmptyTags = true;
				} else {
					opts.buttons = [
						'html', '|', 'formatting', '|', 'bold', 'italic', 'underline', 'deleted', '|',
						'unorderedlist', 'orderedlist', '|', 'alignleft', 'aligncenter', 'alignright', 'justify', '|',
						'image', 'video', 'file', 'table', 'link', '|', 'alignment', '|', 'horizontalrule'
					];
					opts.plugins = ['fontcolor', 'fontsize', 'fontfamily'];
				}

				if ($this.hasClass('datetags')) {
					opts.plugins = ['customTags'];
				}

                opts.plugins = [...(opts.plugins || []), 'safeMustache']

				$this.redactor(opts);

			}
		});

		$('div.displayRedactorOnClick', $target).each(function() {

			var myTextarea = $(this).parent().find('textarea.redactor');

			var opts = {};

			opts.minHeight			= myTextarea.height();
			opts.shortcuts			= false;
			opts.lang				= window.App.lang;

			opts.tidyHtml			= false;
			opts.removeEmptyTags	= false;
			opts.focus				= true;
			opts.linebreaks			= true;

			if(myTextarea.hasClass('noButtons')){
				opts.toolbar = false;
				opts.buttons = [];
			} else if (myTextarea.hasClass('ultraLightButtons')) {
				opts.buttons = ['italic'];
			} else if (myTextarea.hasClass('lightButtons')) {
				opts.buttons = ['bold', 'italic','|', 'unorderedlist', '|', 'outdent', 'indent'];

			}else if (myTextarea.hasClass('tillButtons')) {
				opts.buttons = ['bold', 'italic','|', 'unorderedlist', '|', 'alignment'];
			} else {
				opts.buttons = [
					'html', '|', 'formatting', '|', 'bold', 'italic', 'deleted', '|',
					'unorderedlist', 'orderedlist', 'outdent', 'indent', '|',
					'image', 'video', 'file', 'table', 'link', '|', 'alignment', '|', 'horizontalrule'
				];
				opts.plugins = ['fontcolor', 'fontsize', 'fontfamily'];
			}

			if(myTextarea.hasClass('datetags')){
				opts.plugins = ['customTags'];
			}

            opts.plugins = [...(opts.plugins || []), 'safeMustache']
            RedactorPlugins.safeMustache.safeRedactorOnClick()

			var img = $(this).parent().find('div.beforeRedactor');

			if(img.length == 0) {
				$(this).before('<div class="beforeRedactor"><img src="/ressources/logged/img/docs/redactor-top.png"/></div>');
				var img = $(this).parent().find('div.beforeRedactor');
			}

			img.unbind('click').click(function() {
				myTextarea.show();
				myTextarea.trigger('focus');
			});
			$(this).unbind('click').click(function() {
				myTextarea.show();
				myTextarea.trigger('focus');
			});
			myTextarea.unbind('focus').focus(function(event) {
				$(this).unbind('focus');

				var parent = $(this).parent();
				parent.find('div.beforeRedactor').remove();
				parent.find('div.displayRedactorOnClick').remove();

				$(this).redactor(opts);

				$('.notes .redactor_redactor').find('span.customTag[data-id=custom]').each(function(i, el) {

					var current	= $(el);
					var data	= JSON.parse(atob(current.attr('data-custom')));
					current.find('.modifier').val(data.modifier);
					current.find('.number').val(data.number);
					current.find('.interval').val(data.interval);
					current.find('.format').val(data.format);

				});
			});
		});

        if(withEvent){
			MyFacture.initEvent(target);
		}

		if('body'!==target){
			MyFacture.singleCustomForm(target);
		}

		$('.notes .redactor_redactor').find('span.customTag[data-id=custom]').each(function(i, el) {

			var current	= $(el);
			var data	= JSON.parse(atob(current.attr('data-custom')));
			current.find('.modifier').val(data.modifier);
			current.find('.number').val(data.number);
			current.find('.interval').val(data.interval);
			current.find('.format').val(data.format);

		});

		// Initialize E164 phone inputs
		SmartPhoneNumber.prepareFields($target);

	},

	initEvent: function(target){

		target = undefined === target ? document : target;

		var $target = $(target);

		$('.hasRightClick').not('.rightClickActivated').addClass('rightClickActivated').on('mousedown', function(event){

			if( event.button == 2 ) {
				var rightClickOption = $(this).find('.rightClickOption');
				if (!rightClickOption.hasClass('rightClickEnabled') && rightClickOption.val() !== ""){

					var rcOption	= JSON.parse(rightClickOption.val());
					rightClickOption.closest('.hasRightClick').contextmenu(rcOption);
					rightClickOption.addClass('rightClickEnabled');
				}
				Utils.triggerContextMenu(event, $(this), false);
			}
		});

		$("[e_mousehover]", $target).each(function(){$(this).hover(function(){eval($(this).attr('e_mousehover'));});$(this).removeAttr('e_mousehover');});
		$("[e_mouseout]", $target).each(function(){$(this).mouseleave(function(){eval($(this).attr('e_mouseout'));});$(this).removeAttr('e_mouseout');});
		$("[auto_mousehover]", $target).each(function(){
			$(this).hover(function(){$(this).addClass('hover');});
			$(this).mouseleave(function(){$(this).removeClass('hover');});
			$(this).removeAttr('auto_mousehover');
		});

		$('[e_autogeo]', $target).each(function(){
			Persistent.set($(this).attr('id'), $(this).val(), $(this).parent());

			if($(this).css('display') !== 'none'){
				TokenInput.autoAddress(this);
			}
		});

		$('[e_autostate]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoState(this);
			}
		});

		$('[e_autoitem]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var type = $(this).attr('e_autoitem');
				var more = $(this).attr('e_autoitemmore');
				var max = $(this).attr('e_autoitemmax');
				var callback = $(this).attr('e_autoitemcallback');
				var delcallback = $(this).attr('e_autoitemdelcallback');
				TokenInput.autoItem(this, type, more, max, callback, delcallback);
			}
		});

		$('[e_autoproject]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var more		= $(this).attr('e_autoprojectmore');
				var max			= $(this).attr('e_autoprojectmax');
				var selcallback	= $(this).attr('e_autoprojectselcallback');
				var delcallback	= $(this).attr('e_autoprojectdelcallback');
				TokenInput.autoProject(this, selcallback, delcallback, max, more);
			}
		});

		$('[e_autoprojectentry]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var more		= $(this).attr('e_autoprojectentrymore');
				var max			= $(this).attr('e_autoprojectentrymax');
				var selcallback	= $(this).attr('e_autoprojectentryselcallback');
				var delcallback	= $(this).attr('e_autoprojectentrydelcallback');
				TokenInput.autoProjectEntry(this, selcallback, delcallback, more, max);
			}
		});


		$('[e_autoproposal]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var type			= $(this).attr('e_autoproposal');
				var more			= $(this).attr('e_autoproposalmore');
				var max				= $(this).attr('e_autoproposalmax');
				var selcallback		= $(this).attr('e_autoproposalsel');
				var delcallback		= $(this).attr('e_autoproposaldel');
				var searchonfocus 	= $(this).attr('e_autoproposal_searchonfocus')
				TokenInput.autoProposal(this, type, max, more, selcallback, delcallback, searchonfocus);
			}
		});

		$('[e_autocampaign]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var type		= $(this).attr('e_autocampaign');
				var more		= $(this).attr('e_autocampaignmore');
				var max			= $(this).attr('e_autocampaignmax');
				var provider 	= $(this).attr('e_autocampaignprovider');
				var selcallback	= $(this).attr('e_autocampaignsel');
				var delcallback	= $(this).attr('e_autocampaigndel');
				TokenInput.autoCampaign(this, type, max, more, selcallback, delcallback, provider);
			}
		});

		$('[e_autoaddresses]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var type = $(this).attr('e_autoaddresses');
				var more = $(this).attr('e_autoaddresses_more');
				var max = $(this).attr('e_autoaddresses_max');
				var add = $(this).attr('e_autoaddresses_add');
				var del = $(this).attr('e_autoaddresses_del');
				TokenInput.autoAddresses(this, type, more, max, $(this).attr('e_autoaddresses_add'), add, del);
			}
		});


		$('[e_autoBarcode]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				var whid		= $(this).attr('e_autoBarcodeWhid');
				var inStock		= $(this).attr('e_autoBarcodeInStock');
				var itemid		= $(this).attr('e_autoBarcodeItemid');
				var declid		= $(this).attr('e_autoBarCodeDeclid');
				var callback	= $(this).attr('e_autoBarcodeCallback');
				var max			= $(this).attr('e_autoBarcodeMax');
				var serialOrBarcode  = $(this).attr('e_autoBarcodeSerialOrBarcode');

				TokenInput.autoBarcode(this, itemid, declid, whid, inStock, max, callback, serialOrBarcode);
			}
		});

		$('[e_autocontact]', $target).each(function () {
			if ($(this).css('display') !== 'none') {
				TokenInput.autoContact(
					this,
					$(this).attr('e_autocontact'),
					$(this).attr('e_autocontact_more'),
					$(this).attr('e_autocontact_max'),
					$(this).attr('e_autocontact_add'),
					$(this).attr('e_autocontact_delete')
				);
			}
		});

		$('[e_autocontactGroup]', $target).each(function(){
			if($(this).css('display') !== 'none') TokenInput.autoContactGroup(this, $(this).attr('e_autocontactgroup'), $(this).attr('e_autocontactgroup_linked'), $(this).attr('e_autocontactgroup_more'), $(this).attr('e_autocontactgroup_max'), $(this).attr('e_autocontactgroup_add'), $(this).attr('e_autocontactgroup_delete'));
		});

		$('[e_autopeople]', $target).each(function(){
			if($(this).css('display') !== 'none') TokenInput.autoPeople(this,$(this).attr('e_autopeople_max'), $(this).attr('e_autopeople_searchonfocus'), $(this).attr('e_autopeople_more'),  $(this).attr('e_autopeople_add'), $(this).attr('e_autopeople_delete'), $(this).attr('e_autopeople_custom'));
		});


		$('[e_autocontactlisting]', $target).each(function(){

			if($(this).css('display') !== 'none'){

				var addCallback = $(this).attr('e_autocontactlistingAdd');
				var delCallback = $(this).attr('e_autocontactlistingDelete');

				TokenInput.autoContactListing(this, $(this).attr('e_autocontactlisting'), $(this).attr('e_autocontactlisting_max'), $(this).attr('e_autocontactlisting_searchonfocus'), $(this).attr('e_autocontactlisting_more'), addCallback,delCallback, $(this).attr('placeholder'));
			}
		});

		$('[e_autostaff]', $target).each(function(){

			if($(this).css('display') !== 'none'){
				TokenInput.autoStaff(this,$(this).attr('e_autostaff_max'), $(this).attr('e_autostaff_searchonfocus'), $(this).attr('e_autostaff_more'), $(this).attr('e_autostaff_add'), $(this).attr('e_autostaff_delete'), $(this).attr('e_autostaff_custom'), $(this).attr('e_autostaff_withBlocked'));
			}
		});

		$('[e_autogroup]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoGroup(this, $(this).attr('e_autogroup'), $(this).attr('e_autogroup_max'), $(this).attr('e_autogroup_searchonfocus'), $(this).attr('e_autogroup_more'));
			}
		});

		$('[e_autoattachement]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoAttachement(this, $(this).attr('e_autoattachement'), $(this).attr('e_autoattachementext'), undefined, undefined, undefined, $(this).attr('e_autoattachementname'))
			}
		});

		$('[e_autoattach]', $target).each(
			function(){
				if($(this).css('display') !== 'none'){
					var more = $(this).attr('e_autoattach');
					var ext = $(this).attr('e_autoattachExt');
					var addCallback = $(this).attr('e_autoattachAdd');
					var delCallback = $(this).attr('e_autoattachDelete');
					var max = $(this).attr('e_autoattachMax');
					TokenInput.autoAttachement(this, more, ext, addCallback, delCallback, max);
				}
			}
		);

		// Opportunities
		$('[e_autoprospect]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoProspect(this,$(this).attr('e_autoprospect'), $(this).attr('e_autoprospect_more'), $(this).attr('e_autoprospect_max'), $(this).attr('e_autoprospect_search'));
			}
		});
		$('[e_autoopportunity]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoOpportunity(this, $(this).attr('e_autoopportunity_sel'), $(this).attr('e_autoopportunity_more'), $(this).attr('e_autoopportunity_max'));
			}
		});
		$('[e_autotag]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoTag(this,$(this).attr('e_autotag'));
			}
		});
		$('[e_autodoc]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoDocumentListing(this,$(this).attr('e_autodoc'), $(this).attr('e_autodoc_max'), $(this).attr('e_autodoc_searchonfocus'), $(this).attr('e_autodoc_more'), $(this).attr('e_autodoc_sel'), $(this).attr('e_autodoc_del'), $(this).attr('e_autodoc_context'));
			}
		});
		$('[e_autopromo]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoPromo(this, $(this).attr('e_autopromo'), $(this).attr('e_autopromo_type'), $(this).attr('e_autopromo_docForm'));
			}
		});
		$('[e_autocashtill]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoCashtill(this);
			}
		});
		$('[e_autoticketgroup]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoTicketGroup(this, $(this).attr('e_autoticketgroup'), $(this).attr('e_autoticketgroup_max'), $(this).attr('e_autoticketgroup_searchonfocus') );
			}
		});
		$('[e_autosupport]', $target).each(function(){
			if($(this).css('display') !== 'none'){
				TokenInput.autoSupport(this, "", $(this).attr('e_autosupport_more'));
			}
		});
		$('[e_expenses]', $target).each(function() {
			if($(this).css('display') !== 'none') {
				TokenInput.autoExpensesListing(this, $(this).attr('e_expenses_max'), $(this).attr('e_expenses_searchonfocus'));
			}
		});

		$('[e_send]', $target).each(function() {
			var listingName = $('#listingname');
			var method		= null;
			var change      = $(this).attr('change') != undefined ? $(this).attr('change') : $(this).attr('onchange');
			var form		= $(this).parents().closest('form');

			$(this).unbind('keyup');
			$(this).keyup(_.debounce(function() {

				if($(this).val().length >= $(this).attr('e_send') || $(this).val() === '') {

					if (change) {
						method = change;
					} else if (listingName.length) {
						method = Listing.update(listingName.val(), true, true);
					} else {
						method = form.submit();
					}

					eval(method);
				}
			}, 1000));
		});

		$('[e_enter]', $target).each(function() {
			var listingName = $('#listingname');
			var method		= null;
			var change      = $(this).attr('change') != undefined ? $(this).attr('change') : $(this).attr('onchange');
			var form		= $(this).parents().closest('form');

			$(this).unbind('keyup');
			$(this).keyup(_.debounce(function(event) {

				if(event.which == 13){

					if (change) {
						method = change;
					} else if (listingName.length) {
						method = Listing.update(listingName.val(), true, true);
					} else {
						method = form.submit();
					}

					eval(method);
				}
			}, 1000));

		});

		$('[e_formatnum]', $target).each(function(){

			if (!$(this).hasClass('eformated')){
				var formatvar    = $(this).attr('e_formatvar');
				var formatPrefix = $(this).attr('e_formatprefix');
				var formatempty  = $(this).attr('e_formatempty');
				var formatmax    = $(this).attr('e_formatmax');
				var numformat;

				if (formatvar != undefined){
					numformat = NumberFormat.load(formatvar);
				} else if(formatPrefix != undefined){
					numformat = NumberFormat.loadFromInputs(formatPrefix);
				}else {
					numformat = NumberFormat.load();
				}


				if (($(this).val() != "" && formatempty == "Y") || formatempty != "Y"){
					$(this).val(NumberFormat.formatToDisplay($(this).val(), numformat));
				}

				if (formatmax !== undefined) {
					formatmax = NumberFormat.formatToFloat(formatmax, numformat);
				}

				$(this).change(function(){

					var toFloat = 0;
					if ($(this).val() != "") {
						toFloat = NumberFormat.formatToFloat($(this).val(), numformat);
					}

					if (formatempty == 'Y'){
						if (isNaN(toFloat) || $(this).val() == ""){
							$(this).val('');
							return;
						}
					} else {
						if (isNaN(toFloat)){
							toFloat = NumberFormat.formatToFloat(0, numformat);
						}
					}

					if (formatmax !== undefined && toFloat > formatmax) {
						toFloat = NumberFormat.formatToFloat(formatmax, numformat);
					}

					$(this).val(NumberFormat.formatToDisplay(toFloat, numformat));
				});

			}
		});

        $('[e_autoBankTransaction]', $target).each(function(){
            if($(this).css('display') !== 'none'){
            	TokenInput.autoBankTransaction(this, $(this).attr('e_autoBankTransaction_currencyId'));

            }
        });
	},


	startWait: function() {
        $('#saas-preloader').fadeIn('fast');
    },

    stopWait: function() {
        $('#saas-preloader').fadeOut('fast');
    },

	logout: function(){

		var options = {
			type	: 'warning',
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Déconnexion"),
			buttons		: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text :
					Loc.g("Me déconnecter"),
					click : function(){Utils.relocate('/logout')}
				}
			]
		};

		MyWindow.alert(Loc.g("Vous êtes sur le point de quitter Sellsy !"), options);
	},

	loadThirdQtip: function(){

		$("[tip_type='third']").each(function(){

			$(this).closest('td').attr('onclick', '');

			var relatedId	= $(this).attr('tip_relid');

			$(this).on('click', function() {

				$(this).qtip({
					style : {
						classes : 'custom-qtip rich-qtip',
						def		: false,
					},
					position: {
						viewport: true,
						my : 'top center',
						at : 'bottom center',
					},
					show : {
						event : 'mouseover'
					},
					hide : {
						event: 'mouseout',
						fixed: true,
						delay: 100
					},
					content:{
						ajax: {
							url: '/?_f=thirds',
							type: 'GET',
							data: {
								action		: 'thirdInfos',
								relatedid	: relatedId
							},
							once: true
						}
					}
				});

				$(this).trigger('mouseover');
			});
		});
	},

	loadDeadlinesQtip : function(){
		$("[tip_type=deadlines]").each(function(){
			var relatedId	= $(this).attr('tip_relid');

			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip',
					def		: false,
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center',
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout',
					fixed: true,
					delay: 100
				},
				content: $('#'+relatedId)
			});
		});
	},

	loadPromoQtip: function(){

		$("[tip_type='promo']").each(function(){

			var pid = $(this).attr('tip_promoid');

				var showUseOn	= 'Y';
				if($(this).attr('tip_showuseon') !== undefined && $(this).attr('tip_showuseon') == 'N'){
					showUseOn	= 'N';
				}

				$(this).qtip({
					style : {
						classes : 'custom-qtip rich-qtip',
						def		: false
					},
					position: {
						viewport: true,
						my : 'top center',
						at : 'bottom center'
					},
					show : {
						event : 'mouseover'
					},
					hide : {
						event: 'mouseout',
						fixed: true,
						delay: 100
					},
					content:{
						ajax: {
							url: '/?_f=cataloguepromo',
							type: 'GET',
							data: {
								action		: 'getPromoPrices',
								pid			: pid,
								showUseOn	: showUseOn
							},
							once: true
						}
					}
				});
		});
	},


	linkedDocsQtip : function() {


		$("[tip_type='linked']").each(function(){

			var docid = $(this).attr('tip_docid');
			var doctype = $(this).attr('tip_doctype');




			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip mw-600 p-2',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout',
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						url: '/?_f=purchases_purchases',
						type: 'GET',
						data: {
							action	: 'getLinkedElements',
							doctype : doctype,
							docId	: docid
						},
						once: true
					}
				}
			});
		});
	},
	initQtipDirectDebitLog : function(){


        //check if we are on stripe or gocardless listing
        var actionUrl = $("[tip_type=directDebitLogs]").closest('#stripe_directdebitsListing_container').length ? "./?_f=stripe_stripeDirectdebits" : "./?_f=gocardless_gocardlessDirectdebits";


		$("[tip_type=directDebitLogs]").each(function () {


			var relatedId = $(this).attr('tip_relid');


			$(this).qtip({
				style: {
					classes: 'qtip-custom qtip-rich custom-qtip qtip_directdebitlogs',
					def: false
				},
				position: {
					viewport: true,
					my: 'right top',
					at: 'left center'
				},
				show: {
					event: 'mouseover'
				},
				hide: {
					event: 'mouseout',
					fixed: true,
					delay: 100
				},
				content: {
					text: "<div style='width:100p>x'<i class='fa-20 fa fa-circle-o-notch fa-spin'></i></div>",

					ajax: {
						type: 'GET',
						url: actionUrl,
						data: {
							action		: 'popLogs',
							directDebit	: relatedId
						},
						once: true
					}
				}
			});

		});

	},
	fixLayout : function() {
		$('.navbar, #menu').toggle();
	}
};

window.MyForm = {

	canSubmit : true,
	runningRequest : null,


	defaultOpts: {
		type : "POST"
	},


	processJson: function(data, formId, windowId){

		if (typeof MyWindow != 'undefined'){
			MyWindow.enable(windowId);
		}
		var form = data.form;


		if(form === undefined && data.redirect !== undefined && data.redirect !== null){
			Utils.relocate(data.redirect);
			return true;
		}

		if (form === undefined) {
			return false;
		}


		if(!form.status || form.status !== 'ok'){
			if(form.status === "failed"  && form.formId && form.msg && form.msg.length > 0 && form.msg != ''){
				$('#'+formId).find('.formAlert').html(form.msg).show();
			}

			if(form.fields && form.fields.length > 0){
				var field = null;

				$('[id$=_msg]:visible').each(function(i,el) {
					$(el).css('display', 'none');
				});

				for(var f=0; f < form.fields.length; f++){
					field = form.fields[f];
					MyForm.processField(field.fieldId, field.msg, field.status, field.value);
				}
			}
		}
		if (typeof MyWindow != 'undefined'){
			MyWindow.awake(windowId);
		}


		if(form.status === 'ok' && data.redirect !== undefined && data.redirect !== null){
			Utils.relocate(data.redirect);
			return true;
		}


		return form.status === 'ok';
	},


	processField: function(fieldId, msg, status, value, force){

		force = force ? true : false;

		var skin = "ui-state-error";
		var $field = $('#' + fieldId);

		if(status === 'ok'){
			skin = "";
		}


		if ((status !== 'ok' || force) && Utils.exists(fieldId+"_msg")){
			$("#"+fieldId+"_msg").css("display", "inline-block").find('span').html(msg);
			$field.addClass(skin);
		}

		if ((status !== 'ok' || force) && Utils.exists(fieldId+"_hint")){
			$("#"+fieldId+"_hint").css("color", "#FF6060");
		}

		var fieldIsCustomField = fieldId.indexOf('customfield') !== -1;
		if(fieldIsCustomField){
			var fieldSplit = fieldId.split('_');
			if(['checkbox', 'boolean', 'third', 'item', 'people', 'staff'].indexOf(fieldSplit[2]) !== -1){
				var fieldId = 'formgroupCf_'+fieldSplit[3];
            }
		}

		if(!Utils.exists(fieldId)){
			return false;
		}


		if(value !== undefined){
			$field.val(value);
		}

		if(status !== 'ok' || force){
			if($field.css('display') !== 'none') {

				var isE164PhoneNumber	= $field.hasClass('e164Number');
				var isDatePicker		= $field.hasClass('hasDatepicker');
				var withoutPlaceholder  = $field.hasClass('no-render');

				// Store previous value to reset it on focus
				if(isE164PhoneNumber){
					$field.data('previousValue', $field.intlTelInput('getNumber', intlTelInputUtils.numberFormat.NATIONAL));
				}else{
					$field.data('previousValue', value);
				}

				if (false == withoutPlaceholder) {
					$field.addClass(skin).val(msg);
				}

				$field.one('focus',function(){

					// Reset previous value
					var previousValue = $field.data('previousValue');

					//
					if(isE164PhoneNumber){
						$field.intlTelInput('setNumber', previousValue);
					} else if (isDatePicker) {
						$field.val('');
					} else {
						$field.val(previousValue);
					}

					$field.removeClass(skin);

					$("#"+fieldId+"_msg").fadeOut();
					$("#"+fieldId+"_hint").css("color", "#565665");
				});

			} else {

				// For Token Inputs
				if ($field.is('select')){
					$('#'+fieldId+"-button").addClass(skin);
				} else {
					$field.prev().attr('token','yes').addClass(skin).find('input').css('backgroundColor','#FFE3E8');
				}

				if ($field.is('select')){

					$('#'+fieldId+"-button").click(function(){
						$('#'+fieldId+"-button").removeClass(skin);
					});

				} else {

					$('.redactor_redactor').click(function(){
						$(this).removeClass('ui-state-error');
					});

					/// For Token Inputs
					$('ul[token="yes"]').click(function(){
						$(this).removeClass(skin);
                        $(this).next('input').removeClass(skin);
						$(this).find('input').css('backgroundColor','#fff');
						$("#"+fieldId+"_msg").fadeOut();
						$("#"+fieldId+"_hint").css("color", "#565665");

						$('ul[token="yes"]').each(function(){
							$(this).removeClass(skin);
							$(this).find('input').css('backgroundColor','#fff');
						});
					});

				}

			}

			// if it's a customfield, we expend the cf group is it's not
			if(fieldIsCustomField){
				var cfGroup = $('#'+fieldId).parents('[id*=cfgroupe]');

				if(cfGroup.length > 0 && !cfGroup.is(':visible')){
					var cfGroupInfos 	= cfGroup.attr('id').split('_');

					var cfGroupId 		= cfGroupInfos[1];
					var cfGroupOn 		= cfGroupInfos[2];

					CustomFieldListingTools.toggleCf(cfGroupId, cfGroupOn, 'open');
				}

				// display customfields tab (on doc.)
				if($('#customfields').length > 0){
					$('#customfields').click();
				}

			}
		}


		return true;


	},


	clean: function(formId){


		var $form = $('#' + formId);


		$('.formAlert').html("").hide();
		$('.redactor_redactor.ui-state-error').removeClass('ui-state-error');
        $("select.ui-state-error", $form).removeClass("ui-state-error");
		$("input.ui-state-error, textarea.ui-state-error, select.ui-state-error", $form).val("").removeClass("ui-state-error");
		$("ul.ui-state-error li input", $form).css("background-color", "").val("");
		$("ul", $form).removeClass("ui-state-error");

		$("#"+formId+"_msg").addClass("hidden").removeClass("ui-state-error");
		$(".ui-state-error", $form).removeClass("ui-state-error").not('select').addClass("hidden");


        // Change double braces html to their ascii equivalent
        RedactorPlugins.safeMustache.safeToBack()

	},


	prepare: function(formId, action, options, isPopup, toFreeze, buildURL){

        var $form	= $('#' + formId);
		options		= $.extend({}, MyForm.defaultOpts, options);
		isPopup		= isPopup				? true : false;
		toFreeze	= undefined==toFreeze	? true : false;
		buildURL	= undefined==buildURL	? true : false;

		if(undefined!=action && 0<action.length){

			if(buildURL){
				options.url = MyFacture.buildUrl(action);
			}else{
				options.url = action;
			}
		}
        // Prepare E164 phone numbers
		SmartPhoneNumber.beforeSerialize($form, options);

		var beforeSerialize = options.beforeSerialize;
		options.beforeSerialize = function(){

			if(beforeSerialize !== undefined){
				beforeSerialize.call();
			}

			// placeholders
			$form.find('[defaulttext]').each(function(){
				var defaultText = $(this).attr("defaulttext");
				var placeholder =  new RegExp('^(\s)*'+defaultText+'(\s)*$', 'g');
				var value = $(this).val();
				if(defaultText == value){
					$(this).val(value.replace(placeholder, '')).removeClass('defaulttext');
				}
			});
			MyForm.clean(formId);

		};

		var beforeSubmit = options.beforeSubmit;
		if(options.beforeSend == undefined){
			options.beforeSend = function(jqXHR, options){
				MyForm.runningRequest = jqXHR;
			};
		}

		options.beforeSubmit = function(){

			var submit = false;

			if(formId === 'loginForm' || formId === "registerRequestForm"){
				return true;
			}

			// prevent double submit
			if(MyForm.canSubmit == false){
				submit = false;
			}else{
				MyForm.canSubmit = false;
				submit = true;
			}

			var $multipleSubmits = $('input[name=allowMultipleSubmits]');
			if($multipleSubmits.length == 1 && $multipleSubmits.val() == 1){
				MyForm.canSubmit = true;
				submit = true;
			}

			// Si popup => on freeze la fenêtre
			if(isPopup){
				MyWindow.disable();
				MyWindow.wait(undefined, options.waitMsg);
			}

			var customSubmit = Utils.launch(beforeSubmit);

			return (submit && customSubmit);

		};

		var success = options.success;

		options.success = function(data, status, jqXhr){

			MyForm.canSubmit = true;
			MyForm.runningRequest = null;

			// todo : create popup error
			Utils.launch(success(data));

			$form.find('[defaulttext]').each(function(){
				var placeholder = $(this).attr("defaulttext");
				var value = $(this).val();
				if($(this).val() == ''){
					$(this).val(placeholder).addClass('defaulttext');
				}
			});

		};
		options.error = function(error) {
			MyForm.canSubmit = true;
			MyForm.runningRequest = null;

			if (isPopup) {
				$('div[role=dialog]:visible').each(function() {
					var name = $(this).attr('aria-describedby');
					MyWindow.awake(name);
					MyWindow.enable(name);
				});
			}

			if (error.responseJSON != undefined && error.responseJSON.error != undefined) {
				Push.error(error.responseJSON.error.message);
			} else if (typeof options.customErrorHandler === 'function') {
				options.customErrorHandler(error);
			}
		};

		$form.ajaxForm(options);

	},

	/**
	 * @param {type} params
	 * @example params {
	 *		btn : $('button'),
	 *		dataToCheckOnBody : 'myFormDisabled',
	 *		toEnabled : true,
	 *		[isPopup : true]
	 * }
	 */
	toggleDisabledForm : function(params){

		var paramsDefault = {
			dataToCheckOnBody 	: 'thisFormDisabled',
			textBtnEnabled 		: Loc.g('Enregistrer'),
			textBtnDisabled 	: Loc.g('Chargement') + ' ...',
		};

		var params			= $.extend(paramsDefault, params);
		params.toEnabled	= (typeof params.toEnabled !== 'undefined' ? 'Y' : 'N');

		if(params.btn){
			var btn			= params.btn;
			var body		= $('body');
			var register	= btn.children('span');

			if(body.data(params.dataToCheckOnBody) === undefined){
				body.data(params.dataToCheckOnBody, false);
			}

			if(params.toEnabled == 'Y'){
				btn.removeAttr('disabled');
				register.text(params.textBtnEnabled);
				body.data(params.dataToCheckOnBody, false);
				if(params.isPopup){
					MyWindow.awake('popupWindow');
				}
			} else {
				btn.attr('disabled', 'disabled');
				register.text(params.textBtnDisabled);
				body.data(params.dataToCheckOnBody, true);
				if(params.isPopup){
					MyWindow.wait('popupWindow');
				}
			}
		}
	},


};

window.CheckAlive = {

	forceCheck: function(callback){
		// Check if session is alive, if not (=logout), do fail callback
		MyFacture.post("alive", {}, function (data) {
			CheckAlive.performCallback(data, callback);
		}, "json").fail(function () {
			Utils.launch(callback);
		});
	},

	performCallback: function(data, callback){

		if(data.status == "logout"){
			window.location.reload();
		}
	},

};

window.Qtip = {

	init: function(target){

		target = target == undefined ? $('body') : target;

		target.find("[tips]").qtip({
			style : {
				classes : 'custom-qtip',
				def		: false
			},
			position: {
				viewport: true,
			},
			show : {
				event : 'mouseover'
			},
			hide : {
				event: 'mouseout',
				fixed: true,
				delay: 100
			},
			content:{
				attr : 'tips'
			}
		});

		target.find("[stafftip]").each(function() {

			var $this = $(this);

			$this.on('click', function() {

				$this.closest('td').attr('onclick', '');

				if($this.data('qtip') == undefined) {

					$(this).qtip({
						style : {
							classes : 'custom-qtip rich-qtip',
							def		: false,
						},
						position: {
							viewport: true,
							my : 'top center',
							at : 'bottom center',
						},
						show : {
							event : 'mouseover'
						},
						hide : {
							event: 'mouseout',
							fixed: true,
							delay: 100
						},
						content:{
							ajax: {
								url: '/?_f=staff',
								type: 'GET',
								data: {
									action: 'qtip',
									staffid: $this.attr('stafftip')
								},
								once: true
							}
						}
					});

					$this.trigger('mouseover');
				}

			});
		});


		target.find("[htmltips]").qtip({
			style : {
				classes : 'custom-qtip',
				def		: false
			},
			position: {
				viewport: true,
			},
			show : {
				event : 'mouseover'
			},
			hide : {
				event: 'mouseout',
				fixed: true,
				delay: 100
			},
			content:{
				text : function(event, api) {
					// Retrieve content from custom attribute of the $('.selector') elements.
					return $(this).next('.htmltips-content').clone();
				}
			}
		});

		target.find("[htmltips]").each(function(){

			var $this = $(this);
			var tipsContent = $this.next('.htmltips-content');

			if(tipsContent.length == 0){

				console.error('The htmltips-content class content is missing next to this');

			} else if($this.data('qtip') == undefined) {

				var htmlTipsContent = tipsContent.html();
				tipsContent.hide();
				$this.qtip({
					content: {text: htmlTipsContent},
					position: {
						corner: {
							target: 'leftMiddle',
							tooltip: 'rightMiddle'
						}
					},
					show: 'mouseover',
					hide: {
						fixed: true,
						delay: 0,
					},
					style: {
						'font-size': '11px',
						background: '#3B3B3B',
						color: '#fff',
						a: {
							color: '#cacaca',
							background: '#cbcbcb'
						}

					}
				});

			}
		});

	},

	create: function(options) {

		$(options.element).each(function(){

			var $this = $(this);

			if($this.data("qtip")) $this.qtip("destroy");

			$this.qtip({
				content: $this.attr('customtips'),// Use each elements title attribute
				// Set the tooltip content to the current corner
				position: {
					corner: {
						target: 'bottomMiddle',
						tooltip:"topMiddle"
					}
				},
				show: options.show,
				hide: options.hide, // Don't specify a hide event
				style : {
					tip: {
						color: options.color,
						corner: "topMiddle"
					},
					classes: {tooltip :options.style}
				}
			});

	   });

	}
};

window.Geo = {

	_defaultPrefix: "address_",

	resetTownZip: function(prefix){
		prefix = undefined==prefix ? Geo._defaultPrefix: prefix;
		$("#"+prefix+"town").val("");
		$("#"+prefix+"zip").val("");
	},

	autocompletion: function(field){

		var id = $(field).attr('id');
		var part = id.split('_');
		var fieldName = part[1];
		var prefix = part[0]+'_';

		var field=$('#'+prefix+fieldName);
		field.autocomplete({

            //define callback to format results
		source: function(req, add){

			var value = $.trim(field.val());
			if(3>value.length){
				return false;
			}

			 MyFacture.post("geo", "do=autocompletion&country="+$("#"+prefix+"countrycode").val()+"&field="+fieldName+"&value="+value, function(data, prefix){
			  add( $.map( data[0].towns, function( item )
				{
					return {
							label	: Autocompletion.highlight(item.name+' ('+item.zipcode+')',req.term),
							value	: ('town'== fieldName ? item.name : item.zipcode) ,
							zipcode	: item.zipcode,
							town	: item.name,
							id		: item.id,
							subident: item.subident,
							subname	: item.subname
						   };
				}));
			}, "json");
		},
		minLength: 3,
		delay: 600,
		selectFirst: true,
        //define select handler
        select: function(e, ui) {

            //create formatted friend
            var town	= ui.item.town;
			var id		= ui.item.id;
			var zipcode = ui.item.zipcode;
			var subident = ui.item.subident;
			var subname = ui.item.subname;

			$("#"+prefix+'town').val(town);
			$("#"+prefix+'zip').val(zipcode);
			$("#"+prefix+'state').val(subident);

        }
        }).data( "autocomplete" )._renderItem = function( ul, item ) {
			// only change here was to replace .text() with .html()
			return $( "<li></li>" )
				  .data( "item.autocomplete", item )
				  .append( $( "<a></a>" ).html(item.label) )
				  .appendTo( ul );
        };
	}
};

window.SnippetTrackingWrapper = {

	cookieName : 'sellsysnippet',

	init : function(thirdid, tpcid){

		if(thirdid != '' && tpcid != ''){
			SnippetTrackingWrapper.deleteCookie();
			SnippetTrackingWrapper.saveTrackedUser(thirdid, tpcid);
		}
	},

	deleteCookie : function(){
		document.cookie = [SnippetTrackingWrapper.cookieName, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/;'].join('');
	},

	writeCookie : function(value){
		document.cookie = [SnippetTrackingWrapper.cookieName, '=', JSON.stringify(value), '; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;'].join('');
	},

	readCookie : function(){
		var result = document.cookie.match(new RegExp(SnippetTrackingWrapper.cookieName + '=([^;]+)'));
		result && (result = JSON.parse(result[1]));

		if (result == null){
			result = {};
		}

		return result;
	},

	saveTrackedUser : function(tid, tpcid){

		var _currentCookie    = SnippetTrackingWrapper.readCookie();

		if (typeof _currentCookie === 'object'){
			_currentCookie.usr = {tid:tid, tpcid:tpcid};
			SnippetTrackingWrapper.writeCookie(_currentCookie);
		}

	},
};

window.SellsyError = {

	trigger: function(canal, context, pluginSyscode){
		switch(canal){

			case 'expert' :
				Expert.subscribe();
				break;

			case 'cga' :
				CGA.subscribe();
				break;

			default :
			case 'direct' :
				var winOpt = {
					title : 'Sellsy',
				};

				MyWindow.load('/error/legacy', {action : 'handle', context : context, plugin : pluginSyscode}, winOpt, undefined, undefined, undefined, undefined, false);
				break;
		}

	}

};

(function($) {

	function debounce(callback, delay) {
		var self = this, timeout, _arguments;
		return function() {
			_arguments = Array.prototype.slice.call(arguments, 0),
			timeout = clearTimeout(timeout, _arguments),
			timeout = setTimeout(function() {
				callback.apply(self, _arguments);
				timeout = 0;
			}, delay);

			return this;
		};
	}

	$.extend($.fn, {
		debounce: function(event, callback, delay) {
			this.bind(event, debounce.apply(this, [callback, delay]));
		}
	});

})(jQuery);

if (!Array.indexOf) {
	Array.prototype.indexOf = function(obj) {
		for (var i = 0; i < this.length; i++) {
			if (this[i] === obj) {
				return i;
			}
		}
		return -1;
	};
};

jQuery.expr[':'].insensitivecontains = function(a, i, m) {
	return jQuery(a).text().toUpperCase()
		.indexOf(m[3].toUpperCase()) >= 0;
};
